import { WebVTTParser, Error } from 'webvtt-parser';

// copied from https://www.npmjs.com/package/srt-webvtt
const toVTT = (content: string) => {
  return content
    .replace(/\{\\([ibu])\}/g, '</$1>')
    .replace(/\{\\([ibu])1\}/g, '<$1>')
    .replace(/\{([ibu])\}/g, '<$1>')
    .replace(/\{\/([ibu])\}/g, '</$1>')
    .replace(/(\d\d:\d\d:\d\d),(\d\d\d)/g, '$1.$2')
    .concat('\r\n\r\n');
};
export const srtToVtt = (file: File): Promise<Blob> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('loadend', (event) => {
      const text = event.target?.result?.toString() || '';
      resolve(text);
    });
    reader.addEventListener('error', () => reject());
    reader.readAsText(file);
  }).then((decoded) => {
    const vttString = decoded ? 'WEBVTT FILE\r\n\r\n' : ''; // handle empty srt files
    const text = vttString.concat(toVTT(decoded));
    return new Blob([text], { type: 'text/vtt' });
  });
};
const ignoredErrors = [
  'Only <v> and <lang> can have an annotation.', // This error is thrown when a cue has > or < in the text.
  'Incorrect start tag.', // Related to the above error.
];
export const parseVtt = (text: string) => {
  const parser = new WebVTTParser();
  const result = parser.parse(text);
  return {
    ...result,
    errors: [
      ...result.errors.filter((e) => !ignoredErrors.includes(e.message)),
      ...result.cues
        .filter((c) => c.text.length === 0)
        .map(
          (c): Error => ({
            message: 'Line is empty',
            line: parseInt(c.id, 10),
            col: 0,
          }),
        ),
    ],
  };
};
